import React, { useState, useRef, useEffect } from 'react';

export const Popover = ({ children, className, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popoverRef]);

  return (
    <div
      className={`popover relative ${className}`}
      ref={popoverRef}
      {...props}
    >
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { isOpen, setIsOpen })
      )}
    </div>
  );
};

export const PopoverTrigger = ({ children, isOpen, setIsOpen, className, ...props }) => {
  return (
    <button
      className={`popover-trigger bg-azul-lago text-white p-2 rounded-md hover:bg-azul-lago/80 transition-all ${className}`}
      onClick={() => setIsOpen(!isOpen)}
      {...props}
    >
      {children}
    </button>
  );
};

export const PopoverContent = ({ children, isOpen, className, ...props }) => {
  return isOpen ? (
    <div
      className={`popover-content absolute bg-blanco-nieve text-gris-pizarra border border-azul-lago shadow-md rounded-md p-4 mt-2 w-64 ${className}`}
      {...props}
    >
      {children}
    </div>
  ) : null;
};
